import { Icon } from "@iconify/react/dist/iconify.js";
import "./css/field.css";

const Field = ({ icon, label, value, justify = false }) => (
  <div className="d-flex gap-3 align-items-start p-3 bg-body-secondary rounded-3 border">
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minWidth: "36px", height: "36px" }}
    >
      <Icon icon={icon} width="22" className="text-primary" />{" "}
    </div>
    <div className="flex-grow-1">
      <div
        className="text-uppercase mb-1 fw-medium text-body-secondary"
        style={{ letterSpacing: "0.5px", fontSize: "12px" }}
      >
        {label}
      </div>
      <div className="fw-semibold text-body" style={{ fontSize: "15px", textAlign: justify ? "justify" : "left" }}>
        {value || (
          <span className="text-body-secondary fst-italic">
            No especificado{" "}
          </span>
        )}
      </div>
    </div>
  </div>
);
export default Field;
